import Cookies from 'js-cookie'

const authKey = 'X-Token'

export function getToken() {
    return localStorage.getItem(authKey)
}

export function setToken(token) {
    let loginTime = new Date().getTime();
    Cookies.set('login-time', loginTime);
    localStorage.setItem('login-time', loginTime);
    return localStorage.setItem(authKey, token)
}

export function removeToken() {
    return localStorage.removeItem(authKey)
}